// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportLayout_root__3nwdO"};